var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_7","name":"7","data-vcode":"NUMBER_7","aria-label":"7 PQRS"}},[_c('div',{staticClass:"digit"},[_vm._v("7")]),_c('div',{staticClass:"letters"},[_vm._v("PQRS")])])
}]

export { render, staticRenderFns }